import { CheckCircle2, RefreshCw, WifiOff, X } from "lucide-react";
import { cn } from "@/lib/utils";

export function HeaderOfflineSyncPill({
  tone,
  label,
  detail,
  onDismiss,
}: {
  tone: "offline" | "syncing" | "synced";
  label: string;
  detail: string;
  onDismiss: () => void;
}) {
  const styles =
    tone === "offline"
      ? {
          shell: "border-amber-200/80 bg-amber-50/95 text-amber-800 shadow-[0_10px_30px_-14px_rgba(245,158,11,0.55)]",
          icon: <WifiOff className="h-3.5 w-3.5" />,
        }
      : tone === "syncing"
        ? {
            shell: "border-sky-200/80 bg-sky-50/95 text-sky-800 shadow-[0_10px_30px_-14px_rgba(14,165,233,0.5)]",
            icon: <RefreshCw className="h-3.5 w-3.5 animate-spin" />,
          }
        : {
            shell: "border-emerald-200/80 bg-emerald-50/95 text-emerald-800 shadow-[0_10px_30px_-14px_rgba(16,185,129,0.45)]",
            icon: <CheckCircle2 className="h-3.5 w-3.5" />,
          };

  return (
    <div
      className={cn(
        "pointer-events-auto inline-flex max-w-[min(94vw,34rem)] items-center gap-2 rounded-full border px-3 py-2 backdrop-blur-xl transition-all duration-300",
        styles.shell,
      )}
      aria-live="polite"
    >
      <span className="shrink-0">{styles.icon}</span>
      <div className="min-w-0">
        <p className="truncate text-[11px] font-bold uppercase tracking-[0.2em]">{label}</p>
        <p className="truncate text-[12px] opacity-80">{detail}</p>
      </div>
      <button
        type="button"
        className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white/60 text-current transition-colors hover:bg-white/90"
        aria-label="Dismiss sync status"
        onClick={onDismiss}
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
